import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa'; // Install react-icons if you haven't

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled upto 300px
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <div
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '100px', // Placed above the WhatsApp icon
            right: '30px',
            zIndex: 9999,
            cursor: 'pointer',
            backgroundColor: '#000', // Change to your brand color
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
          }}
        >
          <FaArrowUp size={20} />
        </div>
      )}
    </div>
  );
};

export default ScrollToTop;